module.exports = __webpack_public_path__ + "assets/7b5609315ffa6d987f9c686965a8cc71.png";